// 导入自己需要的组件
import {
  Row,
  Col,
  Carousel,
  CarouselItem,
  Menu,
  Submenu,
  MenuItem,
  Card,
  Tabs,
  TabPane,
  Button,
  Form,
  FormItem,
  Input,
  Breadcrumb,
  BreadcrumbItem,
  MessageBox,
  Message,
  Pagination,
  Dialog,
  Loading
} from 'element-ui'
const element = {
  install: function(Vue) {
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Carousel)
    Vue.use(CarouselItem)
    Vue.use(Menu)
    Vue.use(Submenu)
    Vue.use(MenuItem)
    Vue.use(Card)
    Vue.use(Tabs)
    Vue.use(TabPane)
    Vue.use(Button)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Input)
    Vue.use(Breadcrumb)
    Vue.use(BreadcrumbItem)
    Vue.use(Pagination)
    Vue.use(Dialog)
    Vue.use(Loading)
    // Vue.component(Message)
    // Vue.component(MessageBox)
    Vue.prototype.Message = Message
  }
}
export default element
